export const numberToCurrency = (number, locale) => {
  if (locale === 'ru') return numberFormat(number) + ' ₽'
  return '€' + numberFormat(number)
}

export const numberFormat = number => {
  return new Intl.NumberFormat('ru-RU').format(number)
}
